export default __webpack_public_path__ + "static/media/planticon_5.9e116e0a.png";